import axios from 'axios';
import { LOGOUT_URL } from '../scripts/navigationItems';

// Add additional axios config here if needed
axios.defaults.withCredentials = true;
axios.defaults.baseURL = '/clinical';

// When the backend rejects a replayed cookie (SecurityStamp mismatch),
// ValidatePrincipal returns 401. This interceptor redirects to logout
// so the browser clears the invalid cookie and shows the login page.
axios.interceptors.response.use(
	response => response,
	error => {
		if (error.response?.status === 401) {
			window.location.href = LOGOUT_URL;
		}
		return Promise.reject(error);
	}
);

export default axios;
